// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import { secureRandomString } from 'domains/models';
import Workflow from 'domains/models/workflow';
import { WorkflowType } from 'domains/models/workflow/workflowType';
import Project from 'domains/models/project';
import Routine from 'domains/models/routine';
import { RoutineType } from 'domains/models/routine/routineType';
import { Status } from 'domains/models/routine/status';
import { LinkType } from 'domains/models/routine/linkType';
import { DateTime, getDateTime } from 'infras/datetime';
import Event from 'domains/models/event';
import { scheduledEventListPath } from 'presentations/routes/path';

export const defaultRoutine = (
  userId: string,
  project: Project,
  currentBatchUid: string,
  event: Event,
) => {
  const t = translateInComponent(translations);
  const routine = new Routine({
    routineType: RoutineType.Jicoo,
    eventId: event.id!,
    name: t('name'),
    uid: secureRandomString(),
    projectId: project.id!,
    status: Status.Disable,
    isRemind: true,
    duration: 30,
    linkType: LinkType.Default,
    customLink: scheduledEventListPath({ projectId: project.uid }),
    canDelete: false,
    slackChannel: null,
    userId,
    workflows: defaultWorkflows(),
    currentBatchUid,
    currentBatchEndedAt: null,
    startedAt: getDateTime().startOf('day').toJSDate(),
    endedAt: null,
  });
  return routine;
};

export const defaultWorkflows = () => {
  const t = translateInComponent(translations);
  return [
    new Workflow({
      uid: secureRandomString(),
      workflowType: WorkflowType.QuestionAnswerText,
      content: t('workflow 1'),
      isRequired: false,
      hasOtherChoice: false,
    }),
    new Workflow({
      uid: secureRandomString(),
      workflowType: WorkflowType.Task,
      content: null,
      isRequired: false,
      hasOtherChoice: false,
    }),
    new Workflow({
      uid: secureRandomString(),
      workflowType: WorkflowType.Suggestion,
      content: t('workflow 3'),
      isRequired: false,
      hasOtherChoice: false,
    }),
    new Workflow({
      uid: secureRandomString(),
      workflowType: WorkflowType.Kudos,
      content: t('workflow 4'),
      isRequired: false,
      hasOtherChoice: false,
    }),
  ];
};

export const defaultScheduleItem = (
  wday: number,
  startedAt: DateTime | null = null,
) => {
  return {
    year: null,
    yearInterval: 1,
    month: null,
    monthInterval: 1,
    wday: wday,
    wdayInterval: 1,
    day: null,
    dayInterval: 0,
    hour: startedAt?.hour || 11,
    hourInterval: 0,
    minute: startedAt?.minute || 0,
    minuteInterval: 0,
    exceptions: null,
  };
};
